// extracted by mini-css-extract-plugin
export var table = "_y8-0";